module.exports = __webpack_public_path__ + "static/media/logo.a402149e.svg";